export default __webpack_public_path__ + "static/media/landing.7f18d7f8.png";